export default class Traductor {
  dictionary = {
    ES: {
      password: "Escribe tu contraseña",
      username: "Nombre de usuario",
      email: "Correo electrónico",
      invalidPassword: "La contraseña no es válida",
      invalidEmail: "Correo electrónico no válido",
      login: "Iniciar sesión",
      e14: "E-14",
      votes: "Cuenta votos",
      register: "Ingresar datos",
      claim: "Reclamo",
      witness: "Testigo",
      place: "Puesto",
      corporation: "Corporación",
      takePicture: "Tomar foto",
      table: "Mesa",
      cameraNotAvailable: "La camara no esta disponible.",
      cameraAccessError: "Ocurrio un error al internar aceder a la camara",
      cameraAccessDenied: "Se denegó el acceso a la cámara, permita los permisos en la configuración del navegador",
      repeatPhoto: "Volver a tomar",
      save: "Guardar",
      uploadFile: "Cargar imagen",
      invalidFileType: "Tipo de archivo no soportado",
      dismiss: "Descartar",
      confirm: "Confirmar",
      fileUploadFailed: "Fallo la subida de archivo, intenta otra vez",
      fileUploadSuccess: "La foto se cargó con éxito",
      loginFailed: "Ocurrio un error, intenta mas tarde",
      switch: "Seleccionar mesa",
      politicalParty: "Voto por partido",
      error: "Ocurrio un error, intenta mas tarde",
      registerComplete: "Registro completado con éxito",
      installApp: "Añadir aplicacion al escritorio",
    },
    EN: {
      password: "Write you password",
      username: "Username",
      email: "Email",
      invalidPassword: "The password is not valid",
      invalidEmail: "Invalid email",
      login: "Sign in",
      e14: "E-14",
      votes: "Vote counting",
      register: "Enter data",
      claim: "Claim",
      witness: "Witness",
      place: "Place",
      corporation: "Corporation",
      takePicture: "Take picture",
      table: "Table",
      cameraNotAvailable: "The camera is not available.",
      cameraAccessError: "An error has accoured while trying to access the camera",
      cameraAccessDenied: "Camera access was denied, please allow permissions in the browser settings",
      repeatPhoto: "Repeat photo",
      save: "Save",
      uploadFile: "Upload file",
      invalidFileType: "File type not supported",
      dismiss: "Dismiss",
      confirm: "Confirm",
      fileUploadFailed: "File upload failed, please try again",
      switch: "Select table",
      fileUploadSuccess: "Photo was uploaded successfully",
      loginFailed: "An error has accoured, please try again.",
      politicalParty: "vote by political party",
      error: "An eror has occour, try again.",
      registerComplete: "Register completed successfully",
      installApp: "Add to homescreen",
    },
  };

  constructor(language) {
    this.language = language;
  }

  translate(key) {
    return this.dictionary[this.language][key];
  }
}
